import {useEffect} from 'react';
import {
    useNavigate,
    useParams,
} from 'react-router-dom';
import {Grid} from '@mantine/core';

import {
    FormPageLayout,
    PlatformLoader,
} from '@flexinet/ui-components';

import {RecordForm} from '../forms/RecordForm';
import {Profile} from '../profile/Profile';
import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {useTestDefinition} from '../hooks/useTestDefinition.ts';
import {useTestDefinitionsSelection} from '../hooks/useTestDefinitionsSelection.ts';
import {useEditPageTools} from '../hooks/useEditPageTools';
import {buildInitialValues} from '../forms/buildInitialValues.ts';
import config from '../config';

export const EditPage = () => {

    const {id} = useParams();

    if (typeof id === 'undefined') {
        throw new Error('id is required parameter');
    }

    const navigate = useNavigate();
    const onCancel = () => {
        navigate(`${config.basePath}/${id}`);
    };

    const {
        record,
        updateRecord,
    } = useTestDefinition(id);

    const {handleClearSelection} = useTestDefinitionsSelection();

    const {
        mode,
        tools,
    } = useEditPageTools();

    useEffect(() => {
        handleClearSelection();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- mount-only effect: deliberately runs once, adding deps would re-fire it
    }, []);

    if (!record) {
        return <PlatformLoader message='Loading test definition...Please wait'/>;
    }

    return (
        <FormPageLayout
            title={record.name ? record.name : record.testCode}
            pageNavigation={<EditPageNavigation component={record}/>}
            tools={tools}
        >
            {mode === 'view' ? (
                <Grid>
                    <Grid.Col span={{
                        base: 12,
                        lg: 6
                    }}>
                        <Profile record={record}/>
                    </Grid.Col>
                </Grid>
            ) : (
                <RecordForm
                    record={buildInitialValues(record)}
                    handleSubmit={updateRecord}
                    handleCancel={onCancel}
                />
            )}
        </FormPageLayout>
    );
};
